import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'IF',
  category: FunctionCategory.LOGIC,
  description: 'Returns one value if a logical expression is true, and another if it is false.',
  shortDescription: 'Returns value depending on logical expression',
  params: [
    {
      name: 'logical_test',
      type: ArgType.any,
      description: 'A column or expression that represents some logical value, i.e. true or false.',
    },
    {
      name: 'value_if_true',
      type: ArgType.any,
      description: 'The value to return if logical_test is true.',
    },
    {
      name: 'value_if_false',
      type: ArgType.any,
      description: 'The value to return if logical_test is false.',
    },
  ],
} satisfies AnalysisFunction;
